import { Box, Modal, Typography } from '@mui/material';
import './ServiceCard.css';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
    id: string,
    imageUrl: string,
    videoUrl: string | null,
    serviceTitle: string,
    serviceDescription: string,
    servicesPerRow: number,
    hasVideoHover: boolean
}

const ServiceCard: React.FC<ServiceCardProps> = ({ id, imageUrl, videoUrl, serviceTitle, serviceDescription, servicesPerRow, hasVideoHover }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!hasVideoHover) return;
        const videoElement = event.currentTarget.querySelector('video');
        const imageElement = event.currentTarget.querySelector('img');
        if (videoElement && imageElement) {
            imageElement.style.opacity = '0';
            videoElement.style.opacity = '1';
            videoElement.play().catch(error => console.error('Error playing video:', error));
        }
    };

    const handleMouseLeave = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!hasVideoHover) return;
        const videoElement = event.currentTarget.querySelector('video');
        const imageElement = event.currentTarget.querySelector('img');
        if (videoElement && imageElement) {
            videoElement.pause();
            videoElement.currentTime = 0;
            videoElement.style.opacity = '0';
            imageElement.style.opacity = '1';
        }
    };

    return (
        <Box className="service-card-container service-card-background">
            <Box
                className='image-container'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ cursor: 'pointer' }}
            >
                <img 
                    src={`${process.env.REACT_APP_STATIC_FILE_ROUTE}/${imageUrl}`} 
                    alt="Card Visual" 
                    style={{ display: 'block', width: '100%' }} 
                />
                {videoUrl && (
                    <video
                        src={`${process.env.REACT_APP_STATIC_FILE_ROUTE}/${videoUrl}`}
                        muted
                        loop
                        preload='auto'
                        style={{ opacity: 0, width: '100%' }}
                        onError={() => console.log("Error loading video at", `${process.env.REACT_APP_STATIC_FILE_ROUTE}/${videoUrl}`)}
                    />
                )}
            </Box>
            <Box className='service-card-title-container' id={`${id}-container`}>
                <Typography 
                    className="service-card-title" 
                    sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px', lg: '32px' } }}
                >
                    {serviceTitle}
                </Typography>
            </Box>
            <Box className='service-card-info-container' id={`${id}-container`}>
                <Typography 
                    className="service-card-info" 
                    sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' } }}
                >
                    {serviceDescription}
                </Typography>
            </Box>
            <Box className="service-card-footer">
                <Box
                    component="button"
                    className="read-more-button"
                    onClick={handleOpen}
                >
                    Read More
                </Box>
                <Modal open={open} onClose={handleClose}>
                    <Box className="modal-box">
                        <Typography 
                            id="modal-modal-title" 
                            variant="h4" 
                            component="h2"
                            sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px', lg: '33px' } }}
                        >
                            {serviceTitle}
                        </Typography>
                        <Typography 
                            id="modal-modal-description" 
                            variant='h6' 
                            sx={{ mt: 2, fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' } }}
                        >
                            {serviceDescription}
                        </Typography>
                    </Box>
                </Modal>
            </Box>
        </Box>
    );
};

export default ServiceCard;
